import { Box, ColorOptions, convertHexToRGBA, Icon, IconOptions, ModBox, Spacer, Text } from '@jfs/ui-new'
import { SvgImage } from '../../comps/SvgImage'
import { getStatusFromOrderApi, simpleDateFormat } from '../../util/billPaymentUtil'
import { Colors } from '../../util/util'
import { Logo } from '../BillPayments/Logo'

interface headerInterfacce {
  amount: number
  name?: string
  data?: string
  timestamp: string
  logoPath: string
}

const convertTime = (timestamp) => {
  const dateObj = new Date(timestamp)
  const dateTime = simpleDateFormat(dateObj, 'dd MMM yyyy, hh:mm aaa')
  return dateTime
}
const getIcon = (txnStatus: string, name: string) => {
  if (txnStatus?.match(/SUCCESS|PAYMENT_RECEIVED/i)) {
    return {
      iconId: 'SUCCESSFUL_FILLED',
      status: `${name} Bill Payment`,
      color: '#00B259',
    }
  }
  if (txnStatus?.match(/CONFIRMED/i)) {
    return {
      iconId: 'SUCCESSFUL_FILLED',
      status: `${name} Bill Payment`,
      color: '#00B259',
    }
  }
  if (txnStatus?.match(/FAILED|REFUND_INITIATED|FAILURE/i) && !txnStatus?.match(/REFUND FAILED/i)) {
    return {
      id: 'errorbadge',
      status: 'Payment Failed',
    }
  }
  if (txnStatus?.match(/REFUND ACCEPTED/i)) {
    return {
      iconId: 'SUCCESSFUL_FILLED',
      status: 'Refund Successful',
      color: '#00B259',
    }
  }
  if (txnStatus?.match(/REFUND FAILED/i)) {
    return {
      id: 'errorbadge',
      status: 'Refund Failed',
    }
  }
  if (txnStatus?.match(/INPROCESS/i)) {
    return {
      iconId: 'TIMER' as IconOptions,
      status: 'Payment Processing',
      color: '#FA7D19',
    }
  }
  return {
    iconId: 'INFO',
    status: 'Payment Pending',
    color: '#FA7D19',
  }
}

const formatAmount = (amount) => {
  if (!amount) {
    amount = '0'
  }
  return Number(parseFloat('' + amount).toFixed(2)).toLocaleString('en', {
    minimumFractionDigits: 2,
  })
}
export const Header = ({ amount, name = '', data, timestamp, logoPath }: headerInterfacce) => {
  let status = getStatusFromOrderApi(data)

  const icon = getIcon(status, name)
  return (
    <Box>
      <Box
        justify="center"
        align="center"
        w={56}
        h={56}
        bg={convertHexToRGBA(Colors.PRIMARY, 8) as ColorOptions}
        borderRadius={28}>
        <Box
          w={40}
          h={40}
          borderRadius={20}
          bg={convertHexToRGBA(Colors.PRIMARY, 8) as ColorOptions}
          justify={'center'}
          align={'center'}>
          <Logo logo={logoPath} type={'medium'} fallbackImageName={'report'} />
          {/* <Image borderRadius={20} source={logoPath} resizeMode="cover" width={40} height={40} /> */}
        </Box>
        <ModBox show={!!icon.id} p={1} position={'absolute'} right={-4} bottom={-4} bg={'WHITE'} borderRadius={10}>
          <SvgImage width={10} height={10} imageName={icon.id} />
        </ModBox>
        <ModBox p={1} show={!!icon?.iconId} position={'absolute'} right={-4} bottom={-4} bg={'WHITE'} borderRadius={10}>
          <Icon id={icon.iconId as IconOptions} size={20} color={icon.color as ColorOptions} />
        </ModBox>
      </Box>
      <Spacer size={20} direction={'vertical'} />
      <Text
        title={`${'\u20B9'} ${formatAmount(amount)}`}
        fontFamily={'JioType-Black'}
        fontSize={32}
        lineHeight={32}
        letterSpacing={-0.09}
        color={Colors.BLACK_14 as ColorOptions}
      />
      <Spacer size={6} direction={'vertical'} />
      <Text
        title={icon.status}
        fontFamily={'JioType-Bold'}
        fontSize={16}
        lineHeight={24}
        letterSpacing={-0.09}
        color={Colors.BLACK_14 as ColorOptions}
      />
      <Spacer size={2} direction={'vertical'} />
      <Text
        title={convertTime(timestamp)}
        fontFamily={'JioType-Medium'}
        fontSize={14}
        lineHeight={20}
        letterSpacing={-0.09}
        color={convertHexToRGBA('#000000', 65) as ColorOptions}
      />

      <Spacer size={24} direction={'vertical'} />
    </Box>
  )
}
